import { FIRST_ORDER_INCENTIVE_MODAL } from "@faire/deprecated-retailer-visitor-shared/components/App/AppModals/consts";
import { useBannerText } from "@faire/deprecated-retailer-visitor-shared/components/Notifications/Components/FirstOrderIncentiveBanner/__internal__/useBannerText";
import { trackRetailerFirstOrderIncentiveTermsAndConditionsLearnMoreClick } from "@faire/web-api--source/events/retailerFirstOrderIncentive/click/termsAndConditionsLearnMore";
import { getCurrentPath } from "@faire/web/common/Path";
import { Button } from "@faire/web/slate/Button";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { useHistory } from "react-router-dom";

export const FirstOrderIncentiveBanner: React.FC = () => {
  const history = useHistory();
  const bannerText = useBannerText();

  const onLearnMoreClick = () => {
    trackRetailerFirstOrderIncentiveTermsAndConditionsLearnMoreClick();

    history.replace(
      getCurrentPath()
        .append({ show_modal: FIRST_ORDER_INCENTIVE_MODAL })
        .toString()
    );
  };

  return (
    <>
      <Typography align="center" data-test-id="first-order-incentive-banner">
        {bannerText}{" "}
        <Button variant="tertiary" onClick={onLearnMoreClick}>
          <StrictLocalMsg
            id="rJAsDE"
            defaultMessage="View details"
            description={{
              text: "View detail CTA text to bring up modal",
            }}
          />
        </Button>
      </Typography>
    </>
  );
};
